<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-27 10:41:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-23 14:52:00
 * @Description:
-->
<template>
  <div class="imgList">
    <div class="img-item" v-for="(item, index) in tableData" :key="index">
      <div class="fileUrl-wrap">
        <el-image
          class="fileUrl"
          :src="item.fileUrl || defaultImg"
          :preview-src-list="item.fileUrl ? [item.fileUrl] : null"
        >
          <div slot="error">
            <el-image class="img" :src="defaultImg" :fit="'contain'">
            </el-image>
          </div>
        </el-image>
      </div>
      <div>
        <h2 class="skuName ell_two">{{ item.skuName }}</h2>
        <div class="des-list">
          <div class="ell_one">
            <span>型号：</span>
            <span :title="item.model">{{ item.model }}</span>
          </div>
          <div class="ell_one">
            <span>规格：</span>
            <span :title="item.specification">{{ item.specification }}</span>
          </div>
          <div class="ell_one">
            <span>编号：</span>
            <span :title="item.plcSkuCode">{{ item.plcSkuCode }}</span>
          </div>
          <div class="ell_one">
            <span>标准价：</span>
            <span :title="item.sellingPrice">{{
              item.sellingPrice | formatePrice
            }}</span>
          </div>
        </div>
        <div class="discountSellingPrice">
          ￥{{ item.discountSellingPrice | formatePrice }}
        </div>
        <div class="btns">
          <div @click="toCar(item)" class="car">
            <span>加入购物车</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultImg: require('@/assets/img/goods_default.png')
    }
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  methods: {
    toCar (item) {
      const itemList = [
        {
          goodsNum: 1,
          plcSkuId: item.plcSkuId
        }
      ]
      this.$http
        .post('/front/oms/plc/shoppingCart/addShoppingCartSkuBatch', {
          itemList
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '添加购物车成功'
            })
            this.bus.$emit('getCurrentUserCount')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  padding-top: 9px;
  height: 100%;
}

.imgList {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  overflow: auto;
  height: 100%;
  padding: 12px 16px;
  .img-item {
    width: 278px;
    border: 1px solid #fafafa;
    background: #ffffff;
    border: 1px solid #fafafa;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    margin: 0 0 16px 16px;
    padding: 10px 14px;
    &:hover {
      box-shadow: 0 1px 8px 0 rgba(0,0,0,.14);
    }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
  }
  .fileUrl-wrap {
    text-align: center;
    .fileUrl {
      height: 198px;
    }
  }
  .skuName {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    height: 38px;
    margin: 4px 0 4px;
  }
}

.des-list {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 50%;
    color: #666666;
    font-size: 12px;
    margin-bottom: 4px;
  }
}

.discountSellingPrice {
  font-size: 18px;
  font-weight: 900;
  color: #e93037;
}

.btns {
  display: flex;
  align-items: center;
  padding: 12px 0 0;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #2a54d1;
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    padding: 7.5px 0;
    width: 100%;

    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
